export type Role = ConsoleRoles | DashboardRoles;

export enum ConsoleRoles {
  ADMIN = 'console-backend:console-admin',
  DEVELOPER = 'console-backend:project-manager',
  READER = 'console-backend:console-viewer',
  NONE = 'none',
}

export enum DashboardRoles {
  ADMIN = 'console-backend:dashboard-manager',
  MANAGER = 'manager',
  CONSULTANT = 'console-backend:dashboard-operator',
  INITIATOR = 'console-backend:transaction-data-initiator',
  NONE = 'none',
}
